
// 作业运行状态
export enum Job2Status {
    waiting,		// 等待 = 0
    queue,	        // 队列中 = 1
    running,		// 运行中 = 2
    complete,		// 完成分片作业完成 = 3
    allcomplete = 20,    //实时计算作业完成
    error,			// 错误 = 4
}


export const jobColor = [""]

// 作业状态
export interface IJob2 {
    status: Job2Status,				// 作业状态
    jobName: string,
    log: {
        name: string,
        value: string,
    }[]
}

export interface IJob2s {
    [key: string]: IJob2
}


export interface IJob2Action {
    type: string,
    payload?: IJob2s
}